import React from 'react'
import { css } from 'emotion'
import PropTypes from 'prop-types'
import sanitizeHtml from 'sanitize-html'
import defaultStylesheet from './stylesheet'

const allowedTags = [
   'a', 'b', 'br', 'blockquote', 'code', 'div', 'em',
   'h1', 'h2', 'h3', 'h4', 'h5',
   'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 'u', 'ul', 's', 'span', 'strong',
   'table', 'tbody', 'tr', 'td', 'th', 'thead',
   'left', 'center', 'right',
   'video', 'iframe'
]

const allowedRelAttrConfig = {
   name: 'rel',
   multiple: true,
   values: ['noopener', 'noreferrer', 'nofollow']
}

const sanitize = val => sanitizeHtml(val, {
   allowedTags,
   allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      a: ['href', 'target', allowedRelAttrConfig],
      img: ['src', 'style'],
      td: ['colspan', 'style'],
      th: ['colspan', 'style'],
      iframe: ['src']
   },
   allowedIframeHostnames: ['www.youtube.com'],
   allowedStyles: {
      '*': {
         width: [/^\d+(px|em|%)?$/],
         height: [/^\d+(px|em|%)?$/]
      }
   }
})

const RichText = ({ html, stylesheet }) => {
   const sanitizedHTML = sanitize(html)
   return (
      <div style={{ float: 'left', width: '100%' }}>
         <div
            className={css(stylesheet)}
            dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
         />
      </div>
   )
}

RichText.propTypes = {
   html: PropTypes.string,
   stylesheet: PropTypes.oneOfType([
      // TODO: The way stylesheets should actually work is going to change significantly
      // PR #743
      PropTypes.func,
      PropTypes.object,
      PropTypes.string
   ])
}

RichText.defaultProps = {
   html: '',
   stylesheet: defaultStylesheet
}

export default React.memo(RichText)
